export const ORIGINAL_VIDEO_ID = 'original-video';
export const SCREENSHARE_VIDEO_ID = 'screenshare';
export const DEPRECATED_UPLOAD_SCREENSHARE_ID = 'upload-screenshare';
